import * as tslib_1 from "tslib";
import { ErrorHandler } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import * as Raven from 'raven-js';
import { environment } from '../../environments/environment';
import { isString } from '../util/helpers';
/**
 * Provides a hook for centralized exception handling
 */
var AppErrorHandler = /** @class */ (function (_super) {
    tslib_1.__extends(AppErrorHandler, _super);
    function AppErrorHandler() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Helper method to determine if the given value is an Error object.
     * @param value
     * @returns {boolean}
     */
    AppErrorHandler.isError = function (value) {
        switch ({}.toString.call(value)) {
            case '[object Error]':
                return true;
            case '[object Exception]':
                return true;
            case '[object DOMException]':
                return true;
            default:
                return value instanceof Error;
        }
    };
    /**
     * Handles the given error. In development, this will simply log to the console. In all other environments, this will
     * log the error to Sentry (as well as the console).
     * @param error Error to handle. This can be an instance of an Error object, a string, or an object.
     */
    AppErrorHandler.prototype.handleError = function (error) {
        if (environment.name !== 'development' || environment.forceLogging) {
            this._logError(error);
        }
        _super.prototype.handleError.call(this, error);
    };
    /**
     * Logs an error to Sentry.
     * @param error
     */
    AppErrorHandler.prototype._logError = function (error) {
        if (AppErrorHandler.isError(error)) {
            Raven.captureException(error);
        }
        else {
            var message = this._formatError(error);
            Raven.captureMessage(message);
        }
    };
    /**
     * Formats an error for logging. This method determines the type of error we are logging (Error instance, string,
     * XHR error, an arbitrary object, etc.), and performs a best-effort attempt at formatting the error so as to capture
     * as much information as possible in a format that makes sense for the given error. (Note that the formatted error
     * string will not contain a stack trace - we are relying on Sentry for generating and capturing a stack trace as
     * part of every message that gets logged.)
     * @param e {any} Error to format
     * @returns {string} Formatted error string
     */
    AppErrorHandler.prototype._formatError = function (e) {
        try {
            if (!e) {
                return "AppErrorHandler.logError received a blank error. Please review the stack trace.";
            }
            if (isString(e)) {
                return e;
            }
            if (AppErrorHandler.isError(e)) {
                return "Uncaught " + (e.name || e) + "\n\n";
            }
            if (e instanceof HttpErrorResponse) {
                return "XHR error: " + (e.message || '(Unknown)') + "\n\n" +
                    ("URL: " + (e.url || '(Unknown)') + "\n") +
                    ("Status: " + (e.status || '(Unknown)') + "\n") +
                    ("Status Text: " + (e.statusText || '(None)') + "\n\n") +
                    "Error:\n" +
                    "------\n" +
                    (JSON.stringify(e.error, null, 4) || '(None)');
            }
            return 'Error:\n' +
                '-----\n' +
                (JSON.stringify(e, null, 4) || e || '(Unknown)');
        }
        catch (e2) {
            Raven.captureException(e2);
            return 'An error occurred attempting to format the original error. Please review the stack trace.' +
                '(The formatting exception was logged separately.)';
        }
    };
    return AppErrorHandler;
}(ErrorHandler));
export { AppErrorHandler };
